"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldResetListNumbering = void 0;
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var classnames_1 = __importDefault(require("classnames"));
var TableWidget_1 = __importDefault(require("Project/QwilrEditor/Widgets/TableWidget/TableWidget"));
var VideoWidget_1 = __importDefault(require("Project/QwilrEditor/Widgets/VideoWidget/VideoWidget"));
var VariableWidget_1 = require("Project/QwilrEditor/Widgets/VariableWidget/VariableWidget");
var Promptable_1 = require("Common/Prompt/Promptable");
var Models_1 = require("ContentTokens/Models");
var List_1 = require("ContentTokens/Models/List");
var lodash_1 = require("lodash");
var VariableActions_1 = require("Project/QwilrEditor/Behaviours/VariableActions");
var PromptTypes_1 = require("Prompt/PromptTypes");
var react_1 = __importStar(require("react"));
var slate_1 = require("slate");
var slate_react_1 = require("slate-react");
var ClickDebouncer_1 = require("./ClickDebouncer");
var EditorTypes_1 = require("./EditorTypes");
var Utils_1 = require("./Utils");
var ButtonWidget_1 = __importStar(require("./Widgets/ButtonWidget/ButtonWidget"));
var GoogleMapsWidget_1 = __importDefault(require("./Widgets/GoogleMapsWidget/GoogleMapsWidget"));
var IframeWidget_1 = __importDefault(require("./Widgets/IframeWidget/IframeWidget"));
var ImageWidget_1 = __importStar(require("./Widgets/ImageWidget/ImageWidget"));
var LinkWidget_1 = __importDefault(require("./Widgets/LinkWidget/LinkWidget"));
var SideBySideColumn_1 = require("./Widgets/SideBySideWidget/SideBySideColumn");
var SideBySideContext_1 = require("./Widgets/SideBySideWidget/SideBySideContext");
var SideBySideWidget_1 = __importStar(require("./Widgets/SideBySideWidget/SideBySideWidget"));
var ContentLoopSelection_1 = require("./Widgets/ContentLoopWidget/ContentLoopSelection");
var ContentLoopWidget_1 = __importDefault(require("./Widgets/ContentLoopWidget/ContentLoopWidget"));
var ContentLoopBody_1 = __importDefault(require("./Widgets/ContentLoopWidget/ContentLoopBody"));
var TableCell_1 = __importDefault(require("./Widgets/TableWidget/TableCell"));
var WithUseToolbarState_1 = require("./Widgets/WithUseToolbarState");
var TokenWidget_1 = require("Project/QwilrEditor/Widgets/TokenWidget");
var ROICalculatorWidget_1 = require("./Widgets/ROICalculatorWidget/ROICalculatorWidget");
var AccordionWidget_1 = require("./Widgets/AccordionWidget/AccordionWidget");
var AccordionHeading_1 = require("./Widgets/AccordionWidget/AccordionHeading");
var AccordionBody_1 = require("./Widgets/AccordionWidget/AccordionBody");
var AccordionSelection_1 = require("./Widgets/AccordionWidget/AccordionSelection");
var SlateUtils_1 = require("./Behaviours/SlateUtils");
var ROICalculatorUtils_1 = require("ContentTokens/SharedWidgetComponents/ROICalculator/ROICalculatorUtils");
var Types_1 = require("Tokens/Types");
var WithROISelection_1 = require("./Widgets/ROICalculatorWidget/WithROISelection");
var RepeatingTableRow_1 = __importDefault(require("Project/QwilrEditor/Widgets/TableWidget/RepeatingTableRow"));
var EditorPlaceholder_1 = __importDefault(require("./Placeholder/EditorPlaceholder"));
var ImageWidgetMenu_1 = require("./Widgets/ImageWidget/ImageWidgetMenu/ImageWidgetMenu");
var EmbedPresetsWidget_1 = __importDefault(require("./Widgets/EmbedPresetWidget/EmbedPresetsWidget"));
var EditorWidgetRegistry_1 = require("Project/QwilrEditor/WidgetRegistry/EditorWidgetRegistry");
var RegistryElement_1 = require("./RegistryElement");
var BLOCK_ELEMENT_CLASS = "project-block__block-element";
var renderElement = function (properties, value, editor, widgetManager, onChange, usingFeature, blockStore, brandStore, stylePermissionStore, editorTelemetry, uploadStore, embedUrlGenerator, activeTokenToolbarStore, blockIndex, config, disableWidgetAdder, widgetToolbarHost, dropLocationStore, dragStore, widgetAdderStore, roiStepsOrchestrator, selectionStore, notifyUser) {
    var _a;
    var children = properties.children, element = properties.element, attributes = properties.attributes;
    var pathOfElement = widgetManager.getPath(element);
    var widgetRegistryComponent = (_a = (0, EditorWidgetRegistry_1.getGenericConfigByType)(element.type, true)) === null || _a === void 0 ? void 0 : _a.editorRender;
    if (widgetRegistryComponent) {
        return react_1.default.createElement(RegistryElement_1.RegistryElement, { Widget: widgetRegistryComponent, properties: properties });
    }
    switch (element.type) {
        case EditorTypes_1.BlockType.Paragraph:
            return renderTextElement("p", attributes, editor, element, blockIndex, children, blockStore.isSavedBlock);
        case EditorTypes_1.BlockType.Heading1:
            return renderTextElement("h1", attributes, editor, element, blockIndex, children, blockStore.isSavedBlock);
        case EditorTypes_1.BlockType.Heading2:
            return renderTextElement("h2", attributes, editor, element, blockIndex, children, blockStore.isSavedBlock);
        case EditorTypes_1.BlockType.BlockQuote:
            return renderTextElement("blockquote", attributes, editor, element, blockIndex, children, blockStore.isSavedBlock);
        case EditorTypes_1.BlockType.ListItem:
            return renderListItem(properties, editor);
        case EditorTypes_1.BlockType.Image:
            return renderImageWidget(properties, widgetManager, editorTelemetry, usingFeature, uploadStore, editor, blockStore);
        case EditorTypes_1.BlockType.GoogleMaps:
            return renderGoogleMapsWidget(properties, widgetManager, editorTelemetry, editor, usingFeature, blockStore);
        case EditorTypes_1.BlockType.Iframe:
            return renderIframeWidget(properties, widgetManager, editorTelemetry, editor, usingFeature, blockStore);
        case EditorTypes_1.BlockType.Video:
            return renderVideoWidget(properties, widgetManager, editorTelemetry, embedUrlGenerator, editor, usingFeature, blockStore);
        case EditorTypes_1.BlockType.SideBySide:
            return renderSideBySideWidget(properties, widgetManager, editor, usingFeature);
        case EditorTypes_1.BlockType.SideBySideDummy:
            return renderSideBySideDummy(properties, children);
        case EditorTypes_1.BlockType.SideBySideColumn:
            var usingSidebarImages = usingFeature(FeatureFlag_1.default.SidebarImages);
            return renderSideBySideColumn(properties, (0, lodash_1.last)(pathOfElement), widgetManager, dropLocationStore, usingSidebarImages, dragStore);
        case EditorTypes_1.BlockType.TableRow:
            return (react_1.default.createElement("tr", __assign({ className: (0, classnames_1.default)({
                    "table-header-row": (0, lodash_1.last)(pathOfElement) === 1,
                }) }, attributes), children));
        case EditorTypes_1.BlockType.TableRepeatingRow:
            return renderRepeatingTableRow(properties, widgetManager, (0, lodash_1.last)(pathOfElement) === 1);
        case EditorTypes_1.BlockType.Table:
            return renderTableWidget(properties, editor, widgetManager, usingFeature, blockStore, brandStore, stylePermissionStore, widgetToolbarHost);
        case EditorTypes_1.BlockType.TableDummy:
            return renderTableDummy(properties, children);
        case EditorTypes_1.BlockType.TableCell:
            return (react_1.default.createElement(TableCell_1.default, { attributes: attributes, element: element, widgetManager: widgetManager }, children));
        case EditorTypes_1.InlineType.Link:
            return renderLinkWidget(properties, widgetManager, usingFeature, blockStore, brandStore, stylePermissionStore, config, editor, widgetToolbarHost);
        case EditorTypes_1.InlineType.LineBreak:
            return renderLineBreak(properties);
        case EditorTypes_1.BlockType.HorizontalRule:
            return renderHorizontalRule(properties, widgetManager, editor);
        case EditorTypes_1.BlockType.ContentLoop:
            return renderContentLoopWidget(properties, widgetManager, editor, widgetToolbarHost, blockStore, usingFeature);
        case EditorTypes_1.BlockType.ContentLoopBody:
            return renderContentLoopBody(properties);
        case EditorTypes_1.BlockType.ContentLoopDummy:
            return renderContentLoopDummy(properties, children);
        case EditorTypes_1.InlineType.Variable:
            return renderVariableWidget(properties, widgetManager, activeTokenToolbarStore, editorTelemetry);
        case EditorTypes_1.InlineType.TokenWidget:
            return renderTokenWidget(properties, widgetManager);
        case EditorTypes_1.BlockType.Button:
            return renderButtonWidget(properties, widgetManager, editorTelemetry, blockStore, brandStore, editor, usingFeature);
        case EditorTypes_1.BlockType.ROICalculator:
            return renderROICalculator(properties, editor, widgetManager, brandStore, blockStore, uploadStore, roiStepsOrchestrator, usingFeature, selectionStore, notifyUser);
        case EditorTypes_1.BlockType.Accordion:
            var usingVisualAccordion = usingFeature(FeatureFlag_1.default.AccordionVisual);
            return renderAccordion(properties, editor, widgetManager, blockStore, brandStore, editorTelemetry, usingVisualAccordion, stylePermissionStore);
        case EditorTypes_1.BlockType.AccordionBody:
            return renderAccordionBody(properties, editor, widgetManager, widgetAdderStore);
        case EditorTypes_1.BlockType.AccordionHeading:
            return renderAccordionHeading(properties, editor, widgetManager);
        case EditorTypes_1.BlockType.AccordionDummy:
            return renderAccordionDummy(properties, children);
        default:
            throw new Error("Unrecognised node type provided: ".concat(element.type));
    }
    return null;
};
exports.default = renderElement;
var renderTextElement = function (ElementName, attributes, editor, element, blockIndex, children, isSavedBlock) {
    var textElement = (react_1.default.createElement(ElementName, __assign({}, attributes, { className: BLOCK_ELEMENT_CLASS, onMouseDown: (0, ClickDebouncer_1.debounceClick)(editor, element) }),
        react_1.default.createElement(EditorPlaceholder_1.default, { element: element }),
        children));
    if (!isSavedBlock && blockIndex === 0 && editor.children[0] === element) {
        return react_1.default.createElement(Promptable_1.Promptable, { id: PromptTypes_1.PromptId.EditText }, textElement);
    }
    else {
        return textElement;
    }
};
var renderListItem = function (properties, editor) {
    var element = properties.element, attributes = properties.attributes, children = properties.children;
    var listStyle = {};
    var listClass = BLOCK_ELEMENT_CLASS;
    var listType = element.data.listType;
    var listLevel = element.data.level;
    var LIST_MARGIN_MULTIPLIER = 1.3;
    if (listType == List_1.ListItemType.Bullet) {
        listStyle = {
            marginLeft: "".concat(LIST_MARGIN_MULTIPLIER * (listLevel - 1), "em"),
        };
        listClass += " unordered level-".concat(listLevel);
    }
    else if (listType == List_1.ListItemType.Number) {
        listStyle = {
            marginLeft: "".concat(LIST_MARGIN_MULTIPLIER * (listLevel - 1), "em"),
        };
        listClass += " ordered level-".concat(listLevel);
        var previousBlockEntry = (0, Utils_1.getPrevious)(editor, slate_react_1.ReactEditor.findPath(editor, element), Utils_1.isBlockElement);
        if (previousBlockEntry == null || (0, exports.shouldResetListNumbering)(previousBlockEntry[0], listLevel)) {
            var counterResetStyle = "level".concat(listLevel);
            var startCounter = element.data.startCounter;
            if (startCounter != null) {
                counterResetStyle += " ".concat(startCounter - 1);
            }
            listStyle.counterReset = counterResetStyle;
        }
    }
    return (react_1.default.createElement("li", __assign({ style: listStyle, className: listClass }, attributes),
        react_1.default.createElement("span", null,
            react_1.default.createElement(EditorPlaceholder_1.default, { element: element }),
            children)));
};
var shouldResetListNumbering = function (previousBlock, currLevel) {
    if (!Models_1.ListNode.isListNode(previousBlock)) {
        return true;
    }
    var isOrderedList = previousBlock.data.listType === EditorTypes_1.ListType.Number;
    if (!isOrderedList) {
        return true;
    }
    var isLowerLevel = previousBlock.data.level < currLevel;
    return isLowerLevel;
};
exports.shouldResetListNumbering = shouldResetListNumbering;
var renderLinkWidget = function (_a, widgetManager, usingFeature, blockStore, brandStore, stylePermissionStore, config, editor, widgetToolbarHost) {
    var attributes = _a.attributes, children = _a.children, element = _a.element;
    return (react_1.default.createElement(LinkWidget_1.default, { href: element.data.href, focus: element.data.focus, widgetManager: widgetManager, element: element, usingFeature: usingFeature, blockStore: blockStore, brandStore: brandStore, stylePermissionStore: stylePermissionStore, config: config, isInsideTableCell: isInsideTableCell(editor, slate_react_1.ReactEditor.findPath(editor, element)), isInsideAccordion: (0, SlateUtils_1.hasBlockTypeAsAncestor)({
            selectionPath: slate_react_1.ReactEditor.findPath(editor, element),
            blockType: EditorTypes_1.BlockType.Accordion,
            editor: editor,
        }), attributes: attributes, toolbarHost: widgetToolbarHost }, children));
};
var renderImageWidget = function (_a, widgetManager, editorTelemetry, usingFeature, uploadStore, editor, blockStore) {
    var attributes = _a.attributes, element = _a.element, children = _a.children;
    var path = widgetManager.getPath(element);
    var parentBlockEntry = (0, Utils_1.getClosestBlock)(editor, path);
    var isFirstBlock = path[path.length - 1] === 0;
    var renderMargins = ImageWidget_1.ImageWidgetMarginOption.Both;
    if (parentBlockEntry && parentBlockEntry[0].type === EditorTypes_1.BlockType.SideBySideColumn && isFirstBlock) {
        if (parentBlockEntry[0].children.length === 1) {
            renderMargins = ImageWidget_1.ImageWidgetMarginOption.None;
        }
        else {
            renderMargins = ImageWidget_1.ImageWidgetMarginOption.BottomOnly;
        }
    }
    var imageIsSelected = (0, Utils_1.isSelected)(editor, widgetManager.getPath(element));
    return (react_1.default.createElement(WithUseToolbarState_1.WithUseToolbarState, { isSelected: imageIsSelected, isVoidWidget: true }, function (_a) {
        var isUsingToolbar = _a.isUsingToolbar;
        return (react_1.default.createElement(ImageWidget_1.default, { src: element.data.src, alt: element.data.alt || ImageWidgetMenu_1.AltTextAttributeState.Empty, role: element.data.role || ImageWidgetMenu_1.RoleAttributeState.Empty, width: element.data.width, scale: element.data.scale, translationX: element.data.translation ? element.data.translation.x : undefined, translationY: element.data.translation ? element.data.translation.y : undefined, href: element.data.href, alignment: element.data.alignment, frame: element.data.frame, aspectRatio: element.data.aspectRatio, uploadId: element.data.uploadId, isSelected: imageIsSelected, widgetManager: widgetManager, element: element, telemetry: editorTelemetry, enableImageFrames: usingFeature(FeatureFlag_1.default.ImageFrames), enableTokens: enableTokens(widgetManager, blockStore), uploadStore: uploadStore, renderMargins: renderMargins, attributes: attributes, toolbarBeingUsed: isUsingToolbar, variable: element.data.variable, selectedEmptyInner: element.data.selectedEmptyInner }, children));
    }));
};
var renderGoogleMapsWidget = function (_a, widgetManager, editorTelemetry, editor, usingFeature, blockStore) {
    var element = _a.element, attributes = _a.attributes, children = _a.children;
    var selected = (0, Utils_1.isSelected)(editor, widgetManager.getPath(element));
    return (react_1.default.createElement(WithUseToolbarState_1.WithUseToolbarState, { isSelected: selected, isVoidWidget: true }, function (_a) {
        var isUsingToolbar = _a.isUsingToolbar;
        return (react_1.default.createElement(GoogleMapsWidget_1.default, { displayUrl: element.data.displayUrl, embedUrl: element.data.embedUrl, width: element.data.width, element: element, isSelected: selected, widgetManager: widgetManager, telemetry: editorTelemetry, attributes: attributes, toolbarBeingUsed: isUsingToolbar, enableTokens: enableTokens(widgetManager, blockStore), variable: element.data.variable }, children));
    }));
};
var renderIframeWidget = function (_a, widgetManager, editorTelemetry, editor, usingFeature, blockStore) {
    var element = _a.element, attributes = _a.attributes, children = _a.children;
    var selected = (0, Utils_1.isSelected)(editor, widgetManager.getPath(element));
    return (react_1.default.createElement(WithUseToolbarState_1.WithUseToolbarState, { isSelected: selected, isVoidWidget: true }, function (_a) {
        var isUsingToolbar = _a.isUsingToolbar;
        if (usingFeature(FeatureFlag_1.default.EmbedWidget)) {
            return (react_1.default.createElement(EmbedPresetsWidget_1.default, { embedUrl: element.data.embedUrl, width: element.data.width, height: element.data.height, alignment: element.data.alignment, element: element, isSelected: selected, widgetManager: widgetManager, telemetry: editorTelemetry, attributes: attributes, toolbarBeingUsed: isUsingToolbar, enableTokens: enableTokens(widgetManager, blockStore), variable: element.data.variable, embedPreset: element.data.embedPreset, isUsingWidget: selected || isUsingToolbar }, children));
        }
        else {
            return (react_1.default.createElement(IframeWidget_1.default, { embedUrl: element.data.embedUrl, width: element.data.width, height: element.data.height, element: element, isSelected: selected, widgetManager: widgetManager, telemetry: editorTelemetry, attributes: attributes, toolbarBeingUsed: isUsingToolbar, enableTokens: enableTokens(widgetManager, blockStore), variable: element.data.variable }, children));
        }
    }));
};
var renderVideoWidget = function (_a, widgetManager, editorTelemetry, videoEmbedUrlGenerator, editor, usingFeature, blockStore) {
    var attributes = _a.attributes, element = _a.element, children = _a.children;
    var selected = (0, Utils_1.isSelected)(editor, widgetManager.getPath(element));
    return (react_1.default.createElement(WithUseToolbarState_1.WithUseToolbarState, { isSelected: selected, isVoidWidget: true }, function (_a) {
        var isUsingToolbar = _a.isUsingToolbar;
        return (react_1.default.createElement(VideoWidget_1.default, { toolbarBeingUsed: isUsingToolbar, displayUrl: element.data.displayUrl, embedUrl: element.data.embedUrl, width: element.data.width, isSelected: selected, widgetManager: widgetManager, element: element, telemetry: editorTelemetry, videoEmbedUrlGenerator: videoEmbedUrlGenerator, attributes: attributes, enableTokens: enableTokens(widgetManager, blockStore), variable: element.data.variable }, children));
    }));
};
var getSideBySideSelection = function (editor, path) {
    if (!editor.selection) {
        return SideBySideWidget_1.SideBySideSelectionType.None;
    }
    var anchorNode = slate_1.Editor.node(editor, editor.selection.anchor);
    var anchorIsDummy = (0, Utils_1.hasAncestorOf)(editor, anchorNode[1], EditorTypes_1.BlockType.SideBySideDummy);
    if (slate_1.Range.isCollapsed(editor.selection) && anchorIsDummy && anchorNode[1][0] === path[0]) {
        return SideBySideWidget_1.SideBySideSelectionType.Full;
    }
    var sideBySideBoundaries = { anchor: slate_1.Editor.start(editor, path), focus: slate_1.Editor.end(editor, path) };
    if (slate_1.Range.includes(sideBySideBoundaries, editor.selection.anchor)) {
        return SideBySideWidget_1.SideBySideSelectionType.Inside;
    }
    if (slate_1.Range.isExpanded(editor.selection) &&
        (slate_1.Range.includes(editor.selection, sideBySideBoundaries.anchor) ||
            slate_1.Range.includes(editor.selection, sideBySideBoundaries.focus))) {
        return SideBySideWidget_1.SideBySideSelectionType.Around;
    }
    return SideBySideWidget_1.SideBySideSelectionType.Outside;
};
var renderSideBySideWidget = function (_a, widgetManager, editor, usingFeature) {
    var attributes = _a.attributes, children = _a.children, element = _a.element;
    var path = widgetManager.getPath(element);
    var selection = getSideBySideSelection(editor, path);
    return (react_1.default.createElement(SideBySideWidget_1.default, { enableResizing: usingFeature(FeatureFlag_1.default.SideBySideResizing), width: element.data.width, percent: element.data.percent, alignment: element.data.alignment, widgetManager: widgetManager, attributes: attributes, placeholderIndex: element.data.placeholderIndex, element: element, selection: selection }, children));
};
var renderHorizontalRule = function (_a, widgetManager, editor) {
    var attributes = _a.attributes, element = _a.element, children = _a.children;
    var lineIsSelected = (0, Utils_1.isSelected)(editor, widgetManager.getPath(element));
    var className = lineIsSelected ? "horizontal-rule selected" : "horizontal-rule";
    return (react_1.default.createElement("div", __assign({ className: className }, attributes),
        children,
        react_1.default.createElement("div", { contentEditable: false },
            react_1.default.createElement("hr", { className: BLOCK_ELEMENT_CLASS }))));
};
var renderTableDummy = function (_a, children) {
    var attributes = _a.attributes;
    return (react_1.default.createElement("div", __assign({ style: { position: "fixed", top: "10px", opacity: 0 } }, attributes, { contentEditable: true, suppressContentEditableWarning: true, className: "table-widget__dummy" }), children));
};
var renderSideBySideDummy = function (_a, children) {
    var attributes = _a.attributes;
    return (react_1.default.createElement("div", __assign({ style: {
            position: "fixed",
            top: "-99999px",
            opacity: 0,
        }, className: "side-by-side__dummy" }, attributes), children));
};
var renderRepeatingTableRow = function (_a, widgetManager, isHeaderRow) {
    var attributes = _a.attributes, children = _a.children, element = _a.element;
    return (react_1.default.createElement(RepeatingTableRow_1.default, { attributes: attributes, widgetManager: widgetManager, element: element, isHeaderRow: isHeaderRow, token: element.data.repeatingToken }, children));
};
var renderTableWidget = function (_a, editor, widgetManager, usingFeature, blockStore, brandStore, stylePermissionStore, widgetToolbarHost) {
    var attributes = _a.attributes, children = _a.children, element = _a.element;
    var selected = (0, Utils_1.isSelected)(editor, widgetManager.getPath(element));
    return (react_1.default.createElement(WithUseToolbarState_1.WithUseToolbarState, { isSelected: selected, isVoidWidget: false }, function (_a) {
        var isUsingToolbar = _a.isUsingToolbar;
        return (react_1.default.createElement(TableWidget_1.default, { rows: element.data.rows, columns: element.data.columns, columnBorders: element.data.columnBorders, selection: element.data.selection, widgetManager: widgetManager, attributes: attributes, isSelected: selected, element: element, usingFeature: usingFeature, blockStore: blockStore, brandStore: brandStore, stylePermissionStore: stylePermissionStore, toolbarBeingUsed: isUsingToolbar, widgetToolbarHost: widgetToolbarHost, enableRepeatingTableRows: enableRepeatingTableRows(usingFeature, widgetManager, blockStore), editorSchemaName: editor.schema.name }, children));
    }));
};
var renderContentLoopWidget = function (_a, widgetManager, editor, widgetToolbarHost, blockStore, usingFeature) {
    var attributes = _a.attributes, children = _a.children, element = _a.element;
    var isSelected = (0, ContentLoopSelection_1.isContentLoopSelected)(editor, widgetManager.getPath(element));
    return (react_1.default.createElement(WithUseToolbarState_1.WithUseToolbarState, { isSelected: isSelected, isVoidWidget: false }, function (_a) {
        var isUsingToolbar = _a.isUsingToolbar;
        return (react_1.default.createElement(ContentLoopWidget_1.default, { widgetManager: widgetManager, isSelected: isSelected || isUsingToolbar, widgetToolbarHost: widgetToolbarHost, element: element, attributes: attributes, enableTokens: enableTokens(widgetManager, blockStore), variable: element.data.variable }, children));
    }));
};
var renderContentLoopBody = function (_a) {
    var attributes = _a.attributes, children = _a.children;
    return react_1.default.createElement(ContentLoopBody_1.default, { attributes: attributes }, children);
};
var renderContentLoopDummy = function (_a, children) {
    var attributes = _a.attributes;
    return (react_1.default.createElement("div", __assign({ style: {
            position: "fixed",
            top: "-99999px",
            opacity: 0,
        }, className: "content-loop__dummy", contentEditable: false }, attributes), children));
};
var renderVariableWidget = function (_a, widgetManager, activeTokenToolbarStore, editorTelemetry) {
    var attributes = _a.attributes, children = _a.children, element = _a.element;
    return (react_1.default.createElement(VariableWidget_1.VariableWidget, { activeTokenToolbarStore: activeTokenToolbarStore, variableName: element.data.variableName, variableLabel: element.data.variableLabel, isItalic: element.data[VariableActions_1.VariableStyleKey.IsItalic], isStrikethrough: element.data[VariableActions_1.VariableStyleKey.IsStrikethrough], isBold: element.data[VariableActions_1.VariableStyleKey.IsBold], widgetManager: widgetManager, editorTelemetry: editorTelemetry, attributes: attributes, element: element }, children));
};
var isInsideTableCell = function (editor, path) {
    var ancestors = slate_1.Path.ancestors(path);
    return ancestors.some(function (ancestor) {
        var ancestorNode = slate_1.Editor.node(editor, ancestor)[0];
        return slate_1.Element.isElement(ancestorNode) && ancestorNode.type === EditorTypes_1.BlockType.TableCell;
    });
};
var renderButtonWidget = function (_a, widgetManager, editorTelemetry, blockStore, brandStore, editor, usingFeature) {
    var _b;
    var attributes = _a.attributes, element = _a.element, children = _a.children;
    var alignment = (_b = element.data.alignment) !== null && _b !== void 0 ? _b : ButtonWidget_1.ButtonWidgetAlignment.Center;
    var selected = (0, Utils_1.isSelected)(editor, widgetManager.getPath(element));
    return (react_1.default.createElement(WithUseToolbarState_1.WithUseToolbarState, { isSelected: selected, isVoidWidget: true }, function (_a) {
        var isUsingToolbar = _a.isUsingToolbar;
        return (react_1.default.createElement(ButtonWidget_1.default, { text: element.data.text, href: element.data.href, autoFocus: element.data.autoFocus, isSelected: selected, toolbarBeingUsed: isUsingToolbar, alignment: alignment, widgetManager: widgetManager, telemetry: editorTelemetry, blockStore: blockStore, brandStore: brandStore, element: element, attributes: attributes, tokensEnabled: enableTokens(widgetManager, blockStore) }, children));
    }));
};
var renderTokenWidget = function (_a, widgetManager) {
    var attributes = _a.attributes, element = _a.element, children = _a.children;
    return (react_1.default.createElement(TokenWidget_1.TokenWidget, { attributes: attributes, widgetManager: widgetManager, element: element }, children));
};
var renderSideBySideColumn = function (renderElementProps, columnIdx, widgetManager, dropLocationStore, usingSidebarImages, dragStore) {
    var sbsContext = (0, react_1.useContext)(SideBySideContext_1.SideBySideContext);
    var attributes = renderElementProps.attributes, element = renderElementProps.element;
    return (react_1.default.createElement(SideBySideColumn_1.SideBySideColumn, __assign({ attributes: attributes, columnIdx: columnIdx, widgetManager: widgetManager, dropLocationStore: dropLocationStore, element: element, usingSidebarImages: usingSidebarImages, dragStore: dragStore }, sbsContext), renderElementProps.children));
};
var renderLineBreak = function (renderElementProps) {
    return (react_1.default.createElement("span", __assign({}, renderElementProps.attributes),
        renderElementProps.children,
        react_1.default.createElement("br", null)));
};
var renderROICalculator = function (renderElementProps, editor, widgetManager, brandStore, blockStore, uploadStore, roiStepsOrchestrator, usingFeature, selectionStore, notifyUser) {
    var attributes = renderElementProps.attributes, children = renderElementProps.children, element = renderElementProps.element;
    var _a = element.data, slider = _a.slider, inputs = _a.inputs, roiResult = _a.roiResult, title = _a.title, description = _a.description, variableCounter = _a.variableCounter, backgroundImageUrl = _a.backgroundImageUrl, backgroundImageUploadId = _a.backgroundImageUploadId, hasSelectedPreset = _a.hasSelectedPreset;
    var disableImgix = usingFeature(FeatureFlag_1.default.DisableImgix);
    var optimisedBackgroundImageUrl = backgroundImageUrl
        ? (0, ROICalculatorUtils_1.getOptimisedRoiBackgroundImageUrl)({
            backgroundImageUrl: backgroundImageUrl,
            disableImgix: disableImgix,
        })
        : undefined;
    return (react_1.default.createElement(WithROISelection_1.WithROISelection, { editor: widgetManager.editor, element: element, selectionStore: selectionStore }, function (_a) {
        var selected = _a.selected, editorFocussed = _a.editorFocussed;
        return (react_1.default.createElement(ROICalculatorWidget_1.ROICalculatorWidget, { widgetManager: widgetManager, element: element, attributes: attributes, isSelected: selected, slider: slider, variableInputs: inputs, result: roiResult, brandStore: brandStore, blockStore: blockStore, title: title, description: description, variableCounter: variableCounter, uploadStore: uploadStore, backgroundImageUrl: optimisedBackgroundImageUrl, backgroundImageUploadId: backgroundImageUploadId, hasSelectedPreset: hasSelectedPreset, roiStepsOrchestrator: roiStepsOrchestrator, editorFocussed: editorFocussed, notifyUser: notifyUser }, children));
    }));
};
var renderAccordion = function (_a, editor, widgetManager, blockStore, brandStore, telemetry, usingVisualAccordion, stylePermissionStore) {
    var attributes = _a.attributes, element = _a.element, children = _a.children;
    var selection = (0, AccordionSelection_1.getAccordionSelection)(editor, widgetManager.getPath(element));
    return (react_1.default.createElement(WithUseToolbarState_1.WithUseToolbarState, { isSelected: selection === AccordionSelection_1.AccordionSelectionType.Full, isVoidWidget: false }, function (_a) {
        var isUsingToolbar = _a.isUsingToolbar;
        return (react_1.default.createElement(AccordionWidget_1.AccordionWidget, { widgetManager: widgetManager, element: element, attributes: attributes, selection: selection, isUsingToolbar: isUsingToolbar, blockStore: blockStore, brandStore: brandStore, telemetry: telemetry, expanded: element.data.expanded, backgroundImageUrl: element.data.backgroundImageUrl, usingVisualAccordion: usingVisualAccordion, stylePermissionStore: stylePermissionStore }, children));
    }));
};
var renderAccordionBody = function (renderElementProps, editor, widgetManager, widgetAdderStore) {
    var attributes = renderElementProps.attributes, children = renderElementProps.children, element = renderElementProps.element;
    var selected = (0, Utils_1.isSelected)(editor, widgetManager.getPath(element));
    return (react_1.default.createElement(AccordionBody_1.AccordionBodyWidget, { attributes: attributes, isSelected: selected, widgetAdderStore: widgetAdderStore }, children));
};
var renderAccordionHeading = function (renderElementProps, editor, widgetManager) {
    var attributes = renderElementProps.attributes, children = renderElementProps.children, element = renderElementProps.element;
    var selected = (0, Utils_1.isSelected)(editor, widgetManager.getPath(element));
    return (react_1.default.createElement(AccordionHeading_1.AccordionHeadingWidget, { attributes: attributes, isSelected: selected }, children));
};
var renderAccordionDummy = function (_a, children) {
    var attributes = _a.attributes;
    return (react_1.default.createElement("div", __assign({ style: { width: 0 }, className: "accordion__dummy" }, attributes), children));
};
var enableTokens = function (widgetManager, blockStore) {
    if (widgetManager.isInTemplate()) {
        return Types_1.TokensEnableState.EnabledWithAllInteractions;
    }
    if (blockStore.isSavedBlock) {
        return Types_1.TokensEnableState.EnabledWithoutDragAndDrop;
    }
    return Types_1.TokensEnableState.Disabled;
};
var enableRepeatingTableRows = function (usingFeature, widgetManager, blockStore) {
    if (!usingFeature(FeatureFlag_1.default.PublicApi)) {
        return Types_1.TokensEnableState.Disabled;
    }
    return enableTokens(widgetManager, blockStore);
};
